import { theme } from '@innovamat/innova-components';

import { useWindowSize } from './useWindowSize';

type Breakpoints = {
  isXSmall: boolean;
  isSmall: boolean;
  isMedium: boolean;
  isLarge: boolean;
  isXLarge: boolean;
};

function useBreakpoints(debounceDelay = 100): Breakpoints {
  const windowSize = useWindowSize(debounceDelay);

  const isXSmall =
    !!windowSize.width && windowSize.width >= parseInt(theme.breakpoints.xs);
  const isSmall =
    !!windowSize.width && windowSize.width >= parseInt(theme.breakpoints.sm);
  const isMedium =
    !!windowSize.width && windowSize.width >= parseInt(theme.breakpoints.md);
  const isLarge =
    !!windowSize.width && windowSize.width >= parseInt(theme.breakpoints.lg);
  const isXLarge =
    !!windowSize.width && windowSize.width >= parseInt(theme.breakpoints.xl);

  return { isXSmall, isSmall, isMedium, isLarge, isXLarge };
}

export { useBreakpoints };
